(()=>{
  'use strict';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const mouse=window.matchMedia('(hover: hover) and (pointer: fine)');
  let frame=0,target=0,lastY=0,lastTime=0;
  const maxScroll=()=>Math.max(0,document.documentElement.scrollHeight-window.innerHeight);
  const clamp=value=>Math.max(0,Math.min(maxScroll(),value));
  function stop(){
    if(frame)window.cancelAnimationFrame(frame);
    frame=0;lastTime=0;
  }
  function locked(){
    return document.hidden||Boolean(document.querySelector('dialog[open]'))||
      ['hidden','clip'].includes(window.getComputedStyle(document.body).overflowY)||
      ['hidden','clip'].includes(window.getComputedStyle(document.documentElement).overflowY);
  }
  function nested(element){
    if(!(element instanceof Element))return true;
    if(element.closest('input,textarea,select,[contenteditable="true"],dialog,[aria-modal="true"],iframe,video,audio'))return true;
    for(let node=element;node&&node!==document.body&&node!==document.documentElement;node=node.parentElement){
      if(node.scrollHeight>node.clientHeight+1&&/(auto|scroll|overlay)/.test(window.getComputedStyle(node).overflowY))return true;
    }
    return false;
  }
  function tick(now){
    if(reduced.matches||!mouse.matches||locked()||Math.abs(window.scrollY-lastY)>3){stop();return;}
    const dt=lastTime?Math.min(now-lastTime,40):16.67;
    lastTime=now;target=clamp(target);
    const distance=target-window.scrollY;
    const next=Math.abs(distance)<.75?target:window.scrollY+distance*(1-Math.exp(-dt/65));
    window.scrollTo({top:next,left:window.scrollX,behavior:'instant'});
    lastY=window.scrollY;
    if(Math.abs(target-lastY)<.75){stop();return;}
    frame=window.requestAnimationFrame(tick);
  }
  function wheel(event){
    const fineGesture=event.deltaMode===0&&(Math.abs(event.deltaY)<45||!Number.isInteger(event.deltaY));
    if(event.defaultPrevented||!event.cancelable||event.ctrlKey||event.metaKey||event.shiftKey||
      reduced.matches||!mouse.matches||!event.deltaY||Math.abs(event.deltaX)>Math.abs(event.deltaY)||
      fineGesture||locked()||nested(event.target)){stop();return;}
    const delta=event.deltaY*(event.deltaMode===1?16:event.deltaMode===2?window.innerHeight:1);
    const current=window.scrollY;
    if(!frame||Math.sign(delta)!==Math.sign(target-current)||Math.abs(current-lastY)>3)target=current;
    target=clamp(target+delta);
    if(Math.abs(target-current)<.75){stop();return;}
    event.preventDefault();
    if(!frame){lastY=current;lastTime=0;frame=window.requestAnimationFrame(tick);}
  }
  function configure(){
    stop();window.removeEventListener('wheel',wheel);
    if(!reduced.matches&&mouse.matches)window.addEventListener('wheel',wheel,{passive:false});
  }
  window.addEventListener('pointerdown',stop,{passive:true,capture:true});
  window.addEventListener('touchstart',stop,{passive:true});
  window.addEventListener('keydown',stop,{passive:true});
  window.addEventListener('hashchange',stop);
  window.addEventListener('pagehide',stop);
  window.addEventListener('resize',stop,{passive:true});
  document.addEventListener('visibilitychange',stop);
  reduced.addEventListener('change',configure);
  mouse.addEventListener('change',configure);
  configure();
})();
